import { render, staticRenderFns } from "./DialogActions.vue?vue&type=template&id=797fc40e&scoped=true&"
import script from "./DialogActions.vue?vue&type=script&lang=ts&"
export * from "./DialogActions.vue?vue&type=script&lang=ts&"
import style0 from "./DialogActions.vue?vue&type=style&index=0&id=797fc40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fc40e",
  null
  
)

export default component.exports